<template>
    <div class="row menu-top" :class="{'end-xs': (show)}">
        <div class="col-xs-6 col-sm-4">
            <div class="row start-xs">
                <div class="col-xs-auto toggle" @click="toggle">
                    <button class="btn-toggle">
                        <i class="fa fa-bars fa-2x fa-w"></i>
                    </button>
                </div>
                <div v-if="show" class="col-xs-auto text-left">
                    <img src="@/assets/imgs/logo-blanco-completo.png" class="logo web">
                </div>
            </div>
        </div>
        <div class="col-xs-6 col-sm-6 col-sm-offset-2">
            <div class="row end-xs h-100">
                <div v-if="show" class="col-xs-auto col-sm-4">
                    <button class="btn send f-happy-monkey" @click="send()">
                        <i class="fa fa-send"></i>
                        <img src="@/assets/imgs/enviar.svg" alt="" class="showBtnName">
                    </button>
                </div>
                <div v-if="show" class="col-xs-auto col-sm-4 ">
                    <button class="btn print f-happy-monkey" @click="open()">
                        <i class="fa fa-print"></i>
                        <img src="@/assets/imgs/imprimir.svg" alt="" class="showBtnName">
                    </button>
                    <a :href="'/pdfs/' + link" :download="link" style="display: none" id="btn-download"></a>
                </div>
                <div class="col-xs-0 col-sm-1 col-md-2 "></div>
            </div>
        </div>
        <img src="@/assets/imgs/logo-blanco.png" class="logo mobile" v-if="canShow">
    </div>
</template>

<script>
    export default {
        name: 'top-menu',
        props: {
            show: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            this.getLink();
            /*this.$root.$on('video:playing', () => {
                this.playing = true
                console.log('video event')
            });

            this.$root.$on('video:ended', () => {
                this.playing = false
                console.log('video event')
            });*/

            this.canShow = this.$route.path !== '/';
        },
        data() {
            return {
                links: {
                    '/usar-el-cinturon': 'img1.pdf',
                    '/respetar-las-reglas': 'img2.pdf',
                    '/reducir-la-velocidad': 'img3.pdf',
                    '/proteger-a-los-ninos': 'img4.pdf',
                    '/prestar-atencion': 'img5.pdf',
                    '/manejar-descansado': 'img6.pdf',
                    '/usar-casco': 'img7.pdf',
                    '/ser-cortes': 'img8.pdf',
                    '/revisar-el-auto': 'img9.pdf',
                    '/certificado-gxsv': 'certificado_GXSV.pdf'
                },
                link: '',
                imgShow: 0,
                canShow: false
            }
        },
        methods: {
            getLink() {
                this.link = this.links[this.$route.path];
                this.imgShow = (Object.keys(this.links).indexOf(this.$route.path) + 1);
                console.log('IS', this.imgShow);
            },
            open() {
                this.$emit('showImg', this.imgShow);
                document.querySelector('#btn-download')
                    .click();
            },
            send() {
                this.$emit('send');
            },
            toggle() {
                this.$emit('toggle');
            }
        },
        watch: {
            '$route'() {
                this.getLink();
                this.canShow = this.$route.path !== '/';
            }
        }
    };
</script>

<style lang="sass" scoped>

    .menu-top
        height: 100%
        .logo
            height: 75px
            width: auto
            margin-top: -5px
            margin-bottom: -10px
            max-width: 100%
            &.web
                display: none
                @media screen and (min-width: 48em)
                    display: block
            &.mobile
                display: block
                position: absolute
                top: 10px
                left: 50%
                transform: translateX(-50%)
                @media screen and (min-width: 48em)
                    display: none
        .toggle
            padding: 0
            text-align: center
            @media only screen and (min-width: 48em)
                display: none
            .btn-toggle
                height: 100%
                width: 100%
                text-align: center
                border: none
                background: transparent
                color: white
                cursor: pointer
                transition: all .4s ease-in-out
                outline: none
        .btn
            border-radius: 3em
            box-shadow: 10px 8px 25px 1px rgba(0, 0, 0, 0.2)
            transition: all .5s ease-in-out
            cursor: pointer
            color: #fff
            font-size: 1.5em
            text-align: center
            width: auto
            height: 100%
            max-height: 50px
            position: relative
            padding: 0 16px
            border: none
            vertical-align: middle
            @media only screen and (max-width: 64em)
                font-size: 1.5em
            @media only screen and (max-width: 48em)
                font-size: 1.4em
                height: 50px
                max-height: 50px
                width: 50px
                position: relative
                i
                    @media screen and (max-width: 47.9em)
                        position: absolute
                        top: 50%
                        left: 50%
                        -webkit-transform: translate(-50%, -50%)
                        -moz-transform: translate(-50%, -50%)
                        -ms-transform: translate(-50%, -50%)
                        -o-transform: translate(-50%, -50%)
                        transform: translate(-50%, -50%)
            @media only screen and (max-width: 320px)
                font-size: 1.1em
            @media only screen and (min-width: 48em)
                width: 100%
                padding: 1px 15px
            &.send
                background-color: #f07b7f
                vertical-align: middle
                margin-right: 7.5px
                &:hover
                    background-color: #C0767B

            &.print
                background-color: #63CCA1
                &:hover
                    background-color: #55B18C
            img
                max-width: calc(100% - 35px)
                width: auto
                margin-left: 5px
                height: 20px
                max-height: 100%
                &.showBtnName
                    display: none
                    @media only screen and (min-width: 48em)
                        display: inline-block
            *
                vertical-align: middle
                @media only screen and (min-width: 48em)
                    margin-left: -4px

</style>
